export const fontSize = {
  normal: '1rem',        // 16px
  sm: '0.875rem',        // 14px
  xs: '0.75rem',         // 12px
  lg: '1.125rem',        // 18px
  xl: '1.25rem',         // 20px

  h1: '2.5rem',          // 40px
  h2: '1.5rem',          // 24px
  h3: '1.25rem',         // 20px
  h4: '1.125rem',        // 18px
  h5: '0.875rem',        // 14px

  display1: '2rem',      // 32px
  display2: '1.5rem',    // 24px
  display3: '1.25rem'    // 20px
};

export const lineHeight = {
  normal: '1.5rem',      // 24px
  sm: '1.25rem',         // 20px
  xs: '1rem',            // 16px
  lg: '1.75rem',         // 28px
  xl: '1.75rem',         // 28px

  h1: '3rem',            // 48px
  h2: '2rem',            // 32px
  h3: '1.75rem',         // 28px
  h4: '1.75rem',         // 28px
  h5: '1.25rem',         // 20px

  display1: '3rem',      // 48px
  display2: '2rem',      // 32px
  display3: '1.75rem'    // 28px
};

export const typographyOverrides = {
  // base body sizes
  fontSizeBase100: fontSize.xs,
  fontSizeBase200: fontSize.sm,
  fontSizeBase300: fontSize.normal,
  fontSizeBase400: fontSize.lg,
  fontSizeBase500: fontSize.xl,

  lineHeightBase100: lineHeight.xs,
  lineHeightBase200: lineHeight.sm,
  lineHeightBase300: lineHeight.normal,
  lineHeightBase400: lineHeight.lg,
  lineHeightBase500: lineHeight.xl,

  // headings / display
  fontSizeHero900: fontSize.h1,
  lineHeightHero900: lineHeight.h1,

  fontSizeHero800: fontSize.display1,
  lineHeightHero800: lineHeight.display1,

  fontSizeHero700: fontSize.h2,
  lineHeightHero700: lineHeight.h2,

  fontSizeHero600: fontSize.h3,
  lineHeightHero600: lineHeight.h3,

  fontSizeHero500: fontSize.h4,
  lineHeightHero500: lineHeight.h4,

  fontSizeHero400: fontSize.h5,
  lineHeightHero400: lineHeight.h5,
};